module.exports = __webpack_public_path__ + "img/Bodice-Front-B9-Da-Eb-Fb.b2de4860.png";